import type {
  ChartBaseWithName,
  ChartFeedbackDateRangeOverride,
} from '@/entities/chart/model/types';
import type { FeedbackPeakAnalysisOptions } from '@/features/Feedback/components/FeedbackListModal/peak-analysis';
import { FEEDBACK_COLUMNS } from '@/types/filterKeyConst';
import { getTimezoneDayjs } from '@/utils/time';

import chartUtils from './chart-utils';

export const buildFeedbackPeakAnalysisOptions = (
  chart: ChartBaseWithName,
  options: {
    autoStart?: boolean;
    dateRangeOverride?: ChartFeedbackDateRangeOverride;
  } = {},
): FeedbackPeakAnalysisOptions | undefined => {
  if (!chart.historical.value || !chart.historical.frequency) {
    return undefined;
  }

  const [defaultStartDate, defaultEndDate] = chartUtils.getTimeRangeByTerm(
    getTimezoneDayjs(),
    chart.target.term,
  );
  const startDate = options.dateRangeOverride
    ? getTimezoneDayjs(options.dateRangeOverride.startDate)
    : defaultStartDate;
  const endDate = options.dateRangeOverride
    ? getTimezoneDayjs(options.dateRangeOverride.endDate)
    : defaultEndDate;

  return {
    chartName: chart.name,
    frequency: chart.historical.frequency,
    ...(options.autoStart ? { autoStart: true } : {}),
    filterSet: {
      ...(chart.target.filter ?? {}),
      [FEEDBACK_COLUMNS.DATE_START]: startDate.toJSON(),
      [FEEDBACK_COLUMNS.DATE_END]: endDate.toJSON(),
    },
  };
};
